'use client';

import { varAlpha } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { RADIUS } from 'src/theme/ui-tokens';

/** 동그란 바탕 지름(px) — 카드가 좁아도 실물을 가리지 않는 크기 */
const DISC = 40;
/** 도는 고리 지름(px) */
const RING = 18;

/**
 * 카드·상세의 실물(영상) **위에 얹는 받는 중 표시 — 한 벌뿐이다.** 실물 한가운데 어두운 원 + 흰 고리.
 *
 * 🔑 부르는 쪽이 `position: relative` 인 실물 칸 안에 둔다 — 자리는 이 부품이 정한다(가운데).
 *   주소를 받는 중이든 장면을 받는 중이든 **같은 자리 같은 모양**이라, 한쪽에서 다른 쪽으로 넘어가도 이어져 보인다.
 * ⛔ 실물 위 받는 중 표시를 화면에서 따로 그리지 마라 — 그림 칸의 반짝임(`LoadingImg`)은 별개다.
 * ⚠️ 누름을 막지 않는다(`pointerEvents: none`) — 아래 카드 클릭·훑기가 그대로 간다.
 */
export function MediaBusy({ label }: { label: string }) {
  return (
    <Box
      role="status"
      aria-label={label}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: DISC,
        height: DISC,
        borderRadius: RADIUS.pill,
        bgcolor: (theme) => varAlpha(theme.vars.palette.common.blackChannel, 0.45),
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'none',
      }}
    >
      <CircularProgress size={RING} thickness={5} sx={{ color: 'common.white' }} />
    </Box>
  );
}
